<template>
  <div class="container-main-body">
    <!--按钮开始-->
    <div class="list-container">
      <div v-if="searchShow" class="search-container">
        <el-row>
          <el-col :span="6">
            <div class="search-form-label">样本册：</div>
            <div class="search-form-controller">
              <el-input size="mini" placeholder="样本册" clearable v-model="queryData.sampleName"></el-input>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align: center;">
            <el-button type="warning" size="mini" icon="el-icon-search" plain @click="searchHandler">开始搜索</el-button>
            <el-button type="primary" size="mini" icon="el-icon-delete" plain @click="searchHandler('clear')">清空</el-button>
            <el-button type="danger" size="mini" icon="el-icon-close" plain @click="showSearchHandler()">关闭搜索</el-button>
          </el-col>
        </el-row>
      </div>
      <div class="list-btns-container">
        <el-button-group>
          <el-button
            v-for="btn in $store.state.currentLBtnList"
            :key="btn.id"
            :type="btn.button_type"
            size="mini"
            :icon="btn.button_icon"
            @click="handlerButtonDispatch(btn.fn)"
            >{{ btn.button_name }}</el-button
          >
        </el-button-group>
      </div>
      <!--按钮结束-->
      <!--列表数据 开始-->
      <div class="el-table-container">
        <el-table :data="ds" size="mini" stripe border height="100%" style="width: 100% border:1px solid #d1d1d1"
          header-row-class-name="list-header-row" row-class-name="list-row">
          <el-table-column label="样本册" width="200" prop="sampleName" align="center"></el-table-column>
          <el-table-column label="不良品数量" prop="rejected_number" width="200" align="center"></el-table-column>
          <el-table-column label="修复数量" prop="fixed_number" width="200" align="center">
            <template v-slot:default="scope">
                <el-input size="mini" v-if="scope.row.edit_status==='是'" placeholder="修复数量" v-model="scope.row.fixed_number"></el-input>
                <div v-else style="padding: 0 5px;">{{scope.row.fixed_number}}</div>
            </template>
          </el-table-column>
          <el-table-column label="未修复数量" width="200" align="center">
            <template v-slot:default="scope">
                <div style="padding: 0 5px;">{{scope.row.rejected_number - scope.row.fixed_number}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" header-align="center">
            <template v-slot:default="scope">
              <el-input size="mini" v-if="scope.row.edit_status==='是'" placeholder="备注" v-model="scope.row.remark"></el-input>
              <span v-else>{{scope.row.remark}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="90" align="center">
            <template v-slot:default="scope">
              <el-button v-if="scope.row.edit_status==='否'" type="warning" size="mini" circle icon="el-icon-edit" @click="scope.row.edit_status='是'"></el-button>
              <el-button v-if="scope.row.edit_status==='是'" type="success" size="mini" circle icon="el-icon-finished" @click="handlerSave(scope.row)"></el-button>
              <!-- <el-button v-if="scope.row.edit_status==='否' || scope.row.id === '0'" type="danger" size="mini" circle icon="el-icon-minus" @click="delHandler(scope.row, scope.$index)"></el-button> -->
              <el-button v-if="scope.row.edit_status==='是' && scope.row.id !== '0'" type="info" size="mini" circle icon="el-icon-close" @click="scope.row.edit_status='否'"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-container">
        <el-pagination
          background
          :current-page="queryData.pn"
          :page-size="queryData.pageSize"
          :total="queryData.totalCount"
          :page-sizes="[10, 15, 20, 25, 30, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChange"
          @current-change="pageChange"
        ></el-pagination>
      </div>
    </div>
    <!--列表数据 结束-->
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      ds: [],
      dsDetail: [],
      queryData: {
        sampleName: "",
        pn: 1, // 页码
        pageSize: 20, // 每页条数
        totalCount: 0 // 数据总条数
      },
      searchShow: false,
      operator_id: sessionStorage.getItem("operator_id"),
      isShow: false
    };
  },
  created: function() {},
  mounted: function() {
    this.loadData();
  },
  methods: {
    // 按钮 点击 调度方法
    handlerButtonDispatch: function(fn, args) {
      var _this = this;
      if (typeof _this[fn] === "function") {
        _this[fn].apply(_this, args);
      } else {
        console.log("warning: the method is not exist");
      }
    },
    // 加载数据
    loadData: function() {
      let _this = this;
      _this.post(_this.$apis.getRejectedList, this.queryData, function(
        res
      ) {
        let _json = res.data;
        if (_json.status && _json.status === "logout") {
          _this.logout();
        } else {
          _this.ds = _json.datalist;
          _this.queryData.totalCount = _json.totalCount;
        }
      });
    },
    searchHandler: function(_type) {
      this.queryData.pn = 1;
      if (_type === "clear") {
        this.queryData.sampleName = "";
      }
      this.loadData();
    },
    showSearchHandler: function() {
      this.searchShow = !this.searchShow;
    },
    // 刷新事件
    refreshHandler: function() {
      this.loadData();
    },
    // 页码改变
    pageSizeChange: function(pageSize) {
      this.queryData.pn = 1;
      this.queryData.pageSize = pageSize;
      this.loadData();
    },
    pageChange: function(pn) {
      this.queryData.pn = pn;
      this.loadData();
    },
    handlerSave: function (row) {
      let _this = this
      if (isNaN(row.fixed_number)) {
        _this.$message({
          type: 'error',
          message: '修复数量必须为数字'
        })
        return false
      }
      row.operator_id = _this.operator_id
      _this.post(_this.$apis.saveRejected, row, function (res) {
        let _json = res.data
        if (_json.status === 'ok') {
          _this.$message({
            message: '保存成功',
            type: 'success'
          })
          _this.loadData()
        }
      })
    },
    close: function() {
      this.isShow = false;
    }
  },
  components: {}
};
</script>
